const appSetting = {
  REACT_APP_STRIPE_KEY: atob(window.env.s),
  REACT_APP_API_SUB_DOMAIN: atob(window.env.sd),
  REACT_APP_SHORTENER_SERVER: atob(window.env.ss),
};

export default appSetting;
